(function( $ ) {
    'use strict';

    $( window ).on('load', function() {
        if (window.location.href.indexOf("checkout") === -1) {
            // only run this on the checkout page
            return;
        }

        const cbInstance = window.Chargebee
            ? window.Chargebee.getInstance()
            : null;

        if (!cbInstance) {
            console.error('Could not get Chargebee instance, exiting');
            return;
        }

        // LAYOUT ELEMENTS
        const orderSummary = document.querySelector('#order-summary');
        const columnsWrapper = orderSummary.parentNode;
        // FORMS
        const guestCheckoutFormWrapper = document.querySelector('#ck-guest-form');
        const guestCheckoutForm = document.querySelector('#ck-guest-email-form');
        const checkoutForm = document.querySelector('#ck-user-form');
        const loginForm = document.querySelector('#checkout-login-form');
        const shippingForm = document.querySelector('#shipping-address-form');
        const contactDetailsForm = document.querySelector('#klira-checkout-contact-details');
        const paymentForm = document.querySelector('#klira-checkout-payment-details');
        // FORM FIELDS
        const guestEmailField = document.querySelector('input[name="form_fields[acc_guest_email]"]')
        const loginEmailField = document.querySelector('#login_form input[name="form_fields[login_email]"]')
        const loginPasswordInput = document.querySelector('#login_form input[name="form_fields[login_password]"]')
        const checkoutEmailField = document.querySelector('#form-field-acc_email');
        const couponField = document.querySelector('.kl-coupon');
        // FORM PAYMENT FIELDS
        const inputCardNumber = document.querySelector('#form-field-kl_card_number');
        const inputCardExpiry = document.querySelector('#form-field-kl_expiry_date');
        const inputCardCvv = document.querySelector('#form-field-kl_cvv');
        // NAVIGATION LINKS/BUTTONS
        const continueToPaymentBtn = document.querySelector('#kl-checkout-continue-to-payment');
        const backToContactDetailsBtn = document.querySelector('#klira-checkout-back-to-contact-details');
        // FORM BUTTONS
        const couponApplyButton = document.querySelector('#apply-coupon-btn');
        const purchaseBtn = document.querySelector('#kl-checkout-btn')
        const purchaseBtnMobi = document.querySelector('#kl-checkout-btn-mobile')
        const phonePurchaseBtn = document.querySelector('#phone-payment-button')
        const phonePurchaseBtnMobi = document.querySelector('#phone-payment-button-mobile')
        // FORM LABELS
        const shippingFormTitle = document.querySelector('#shipping-address-title');








        const cardNumberInput = document.querySelector(
            'input[name="form_fields[kl_card_number]"]'
        )
        const expiryInput = document.querySelector(
            'input[name="form_fields[kl_expiry_date]"]'
        )
        const cvvInput = document.querySelector('input[name="form_fields[kl_cvv]"]')

        const PAYMENT_METHOD_CARD = 'card';
        const PAYMENT_METHOD_CARD_EXISTING = 'card-existing';
        const PAYMENT_METHOD_GOOGLE_PAY = 'gpay';
        const PAYMENT_METHOD_APPLE_PAY = 'apay';








        // event handlers
        document.querySelector('form[name="account-detail-guest"]')?.addEventListener(
            'submit',
            async function() {
                if (!validateEmail(guestEmailField.value)) {
                    window.utils.forms.addErrorMessage('Please check your email is formatted correctly', guestEmailField);
                    return;
                }

                // reset this field, we'll fill it in for the new email address
                window.checkout.emailUserAccountExists = false;

                // save the email
                window.utils.forms.updateFieldAndTriggerChangeEvent(checkoutEmailField, guestEmailField.value);

                try {
                    window.utils.animations.addLoadingSpinner(guestCheckoutFormWrapper);
                    console.log("CHECKOUT: Checking whether email exists");
                    const responseJson = await window.utils.request.post(
                        '/wp-json/klira/user/email-exists',
                        {
                            email: window.checkout.email,
                            login_if_email_does_not_exist: true,
                        }
                    );
                    console.log("CHECKOUT: Check complete, processing response");

                    window.utils.animations.removeLoadingSpinner(guestCheckoutFormWrapper);

                    let responseObj = JSON.parse(responseJson);

                    if (responseObj.exists) {
                        console.log("CHECKOUT: Email exists, prompting for login");
                        window.checkout.emailUserAccountExists = true;
                        // email address exists, ask them to login
                        showLoginForm();
                        hideGuestForm();
                    } else {
                        console.log("CHECKOUT: Email does not exist");

                        if (responseObj.loggedIn) {
                            console.log("CHECKOUT: User was logged in, refreshing page");
                            // we just logged them in, refresh the page
                            window.location.reload();
                            return;
                        }

                        window.checkout.emailUserAccountExists = false;
                        // email address doesn't exist
                        hideGuestForm();
                        hideGuestArea();
                        showCheckoutForm();
                    }

                    // save the checkout so we retain the info on whether the user email exists or not
                    window.checkout.save();
                } catch (error) {
                    console.error('ERROR: ', error);
                }
            }
        );

        // logging in on checkout
        document.querySelector('#checkout-login-form')?.addEventListener(
            'submit',
            async function() {
                window.utils.forms.removeErrorMessage(loginPasswordInput);

                if (!validateEmail(loginEmailField.value)) {
                    window.utils.forms.addErrorMessage('Please check your email is formatted correctly', loginEmailField);
                    return;
                }

                try {
                    window.utils.animations.addLoadingSpinner(guestCheckoutFormWrapper);

                    const responseJson = await window.utils.request.post(
                        '/wp-json/klira/user/login',
                        {
                            username: loginEmailField.value,
                            password: loginPasswordInput.value,
                            is_checkout: true,
                        }
                    );

                    window.utils.animations.removeLoadingSpinner(guestCheckoutFormWrapper);

                    let responseObj = JSON.parse(responseJson);

                    if (responseObj.success) {
                        // clear the checkout data, so we don't show empty fields
                        window.checkout.clear();
                        window.utils.animations.addLoadingSpinner(document.querySelector('body'));
                        // reload so details are retrieved
                        window.location.reload()
                    } else {
                        // error!
                        window.utils.forms.addErrorMessage('Password is incorrect. Please try again.', loginPasswordInput);
                    }
                } catch (error) {
                    console.error('ERROR: ', error);
                }
            }
        );

        // applying a coupon
        couponApplyButton?.addEventListener(
            'click',
            async function() {
                window.utils.forms.removeErrorMessage(couponField);

                if (!couponField.value || couponField.value.length < 3) {
                    window.utils.forms.addErrorMessage('Please enter your coupon code', couponField);
                    return
                }

                let code = couponField.value.trim();

                // clear the field
                couponField.value = '';

                window.utils.animations.addLoadingSpinner(orderSummary);
                let couponAdded = await window.cart.addCoupon(code);
                window.utils.animations.removeLoadingSpinner(orderSummary);

                if (!couponAdded) {
                    // the coupon wasn't added, display the error
                    window.utils.forms.addErrorMessage(`Could not add coupon ${code}`, couponField);
                    await window.cart.removeCoupon(code);
                }

                // re-render the order summary to pull in the new prices
                await renderOrderSummary();
            }
        )

        // removing a coupon
        document.addEventListener(
            'click',
            async function (event) {
                if (!event.target.matches('.kl-coupon-remove')) {
                    return;
                }

                const removeButton = event.target;

                const couponCode = removeButton.dataset.code;

                if (!couponCode) {
                    console.error("No Coupon Code found on this remove button");
                    return;
                }

                window.utils.animations.addLoadingSpinner(orderSummary);
                await window.cart.removeCoupon(couponCode);
                window.utils.animations.removeLoadingSpinner(orderSummary);

                // re-render the order summary to pull in the new prices
                await renderOrderSummary();
            }
        );

        // removing a cart item
        document.addEventListener(
            'click',
            async function (event) {
                if (!event.target.matches('.kl-cart-item-remove')) {
                    return;
                }

                const removeButton = event.target;

                const productId = removeButton.dataset.id;

                if (!productId) {
                    console.error("No product ID found on this remove button");
                    return;
                }

                window.utils.animations.addLoadingSpinner(orderSummary);
                await window.cart.removeItem(productId);
                window.utils.animations.removeLoadingSpinner(orderSummary);

                // re-render the order summary to pull in the new prices
                await renderOrderSummary();
            }
        );

        // resetting checkout if using wrong email
        document.addEventListener(
            'click',
            async function (event) {
                if (!event.target.matches('.not-you-button')) {
                    return;
                }

                // reset the checkout
                window.checkout.clear();

                // re-render the forms
                showHideEmailAndLoginForms();

                event.preventDefault();
                return false;
            }
        );

        // payment method selection
        document.addEventListener(
            'change',
            async function (event) {
                let theInput = event.target;

                if (!theInput.matches('input[name="method"]')) {
                    return;
                }

                showHideSelectedPaymentDetails();
            }
        );

        document.addEventListener(
            window.payment.events.phonePaymentModalComplete,
            async function(event) {
                console.log('CHECKOUT: Received event', event.detail);
                if (event.detail.authorised) {
                    await startCheckoutProcess();
                } else if (event.detail.error) {
                    window.payment.clearPaymentIntent();
                    window.utils.forms.addErrorMessage(event.detail.error, checkoutForm, 5, false);
                }
            },
            false,
        );

        // @TODO Can these be combined?
        purchaseBtn?.addEventListener('click', async function(e) {
            e.preventDefault()
            e.stopImmediatePropagation()

            await startCheckoutProcess()
        })
        // @TODO Can these be combined? Does the mobile one need the event to propagate?
        purchaseBtnMobi?.addEventListener('click', async function() {
            await startCheckoutProcess()
        })


        // NAVIGATION
        continueToPaymentBtn?.addEventListener('click', async function(e) {
            e.preventDefault()
            e.stopImmediatePropagation()

            await moveToPaymentStep()
        })

        backToContactDetailsBtn?.addEventListener('click', async function(e) {
            e.preventDefault()
            e.stopImmediatePropagation()

            await moveToContactDetailsStep()
        })















        function validateEmail(email) {
            return email.trim().match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
        }

        function isValidUKPostalCode(postalCode) {
            const postcodeRegex = /^(GIR 0AA|[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2})$/i

            return postcodeRegex.test(postalCode.trim())
        }

        function lockFields() {
            // we get the email either from the guest form or from the logged-in user, disable the field
            checkoutEmailField.disabled = true;
            // we don't allow them to change their country
            checkoutForm.querySelector('#form-field-ba_country').disabled = true;
            checkoutForm.querySelector('#form-field-sa_country').disabled = true;
        }

        function addCardFormFormattingListeners() {
            cardNumberInput.setAttribute('maxlength', '19')

            cardNumberInput.addEventListener('input', function(event) {
                const value = event.target.value.replace(/\D/g, '')
                let formattedValue = ''
                for (let i = 0; i < value.length; i += 4) {
                    if (i > 0) {
                        formattedValue += ' '
                    }
                    formattedValue += value.substring(i, i + 4)
                }
                event.target.value = formattedValue
            })

            expiryInput.addEventListener('input', function(event) {
                let value = event.target.value.replace(/\D/g, '')
                if (value.length > 4) {
                    value = value.substring(0, 4)
                }
                if (value.length > 2) {
                    value = value.slice(0, 2) + ' / ' + value.slice(2)
                }
                event.target.value = value
            })

            cvvInput.addEventListener('input', function(event) {
                let value = event.target.value.replace(/\D/g, '')
                if (value.length > 4) {
                    value = value.substring(0, 4)
                }
                event.target.value = value
            })
        }

        function showHideEmailAndLoginForms() {
            if (window.customer.isLoggedIn()) {
                // logged in
                hideGuestArea();
                hideLoginForm();
                hideGuestForm();
                showCheckoutForm();
                showContactDetailsForm();
            } else if (window.checkout.hasProvidedEmail() && !window.checkout.emailUserAccountExists) {
                // not logged in, but this is a new account
                hideGuestArea();
                hideLoginForm();
                hideGuestForm();
                showCheckoutForm();
                showContactDetailsForm();
            } else {
                // not logged in and either they submitted an email that already exists or they haven't submitted anything yet
                showGuestArea();
                hideLoginForm();
                hideCheckoutForm();
                showGuestForm();
                hidePaymentForm();
            }
        }

        function showHideShippingAddressForm() {
            if (window.checkout.shipToBillingAddress) {
                window.utils.content.hide(shippingForm);
                window.utils.content.hide(shippingFormTitle);
            } else {
                window.utils.content.show(shippingForm, 'block');
                window.utils.content.show(shippingFormTitle, 'block');
            }
        }

        function showGuestArea() {
            window.utils.content.show(guestCheckoutFormWrapper, 'block');
        }
        function showCheckoutForm() {
            window.klira.klaviyo.trackCheckoutStarted().then(r => console.log('Tracked checkout started event'));
            window.utils.content.show(checkoutForm, 'block');
        }
        function showGuestForm() {
            window.utils.content.show(guestCheckoutForm, 'block');
        }
        function showLoginForm() {
            window.utils.content.show(loginForm, 'block');
            loginForm.querySelector('input[name="form_fields[login_email]"]').value = window.checkout.email || '';
        }
        function showContactDetailsForm() {
            window.utils.content.show(contactDetailsForm, 'block');
            // don't show both forms at the same time
            hidePaymentForm();
        }
        function showPaymentForm() {
            // show complete purchase buttons
            if (!isPaymentMethodPhoneProvider()) {
                showCompletePurchaseButtons();
            }
            window.utils.content.show(paymentForm, 'block');
            // don't show both forms at the same time
            hideContactDetailsForm();
        }
        function hideGuestArea() {
            window.utils.content.hide(guestCheckoutFormWrapper);
        }
        function hideCheckoutForm() {
            window.utils.content.hide(checkoutForm);
        }
        function hideGuestForm() {
            window.utils.content.hide(guestCheckoutForm);
        }
        function hideLoginForm() {
            window.utils.content.hide(loginForm);
        }
        function hideContactDetailsForm() {
            window.utils.content.hide(contactDetailsForm);
        }
        function hidePaymentForm() {
            // hide complete purchase buttons
            hideCompletePurchaseButtons();
            window.utils.content.hide(paymentForm);
        }




        // populates the checkout form based on existing user data or submitted data
        function fillCheckoutForm() {
            // account details
            bindCheckoutField('#form-field-acc_email', window.checkout,'email');
            bindCheckoutField('#form-field-acc_fn', window.checkout, 'first_name');
            bindCheckoutField('#form-field-acc_ln', window.checkout, 'last_name');
            bindCheckoutField('#form-field-acc_phone', window.checkout, 'phone');
            bindCheckoutCheckbox('#form-field-sign_up_skinsize-0', window.checkout, 'marketing_opt_in');

            // billing details
            bindCheckoutField('#form-field-ba_fn', window.checkout.billing, 'first_name');
            bindCheckoutField('#form-field-ba_ln', window.checkout.billing, 'last_name');
            bindCheckoutField('#form-field-ba_address1', window.checkout.billing, 'address');
            bindCheckoutField('#form-field-ba_address2', window.checkout.billing, 'address2');
            bindCheckoutField('#form-field-ba_city', window.checkout.billing, 'city');
            bindCheckoutField('#form-field-ba_county', window.checkout.billing, 'state');
            bindCheckoutField('#form-field-ba_postal_code', window.checkout.billing, 'zip');
            // bindCheckoutField('#form-field-ba_country', window.checkout.billing, 'country');
            checkoutForm.querySelector('#form-field-ba_country').value = 'United Kingdom';

            // shipping details
            bindCheckoutField('#form-field-sa_fn', window.checkout.shipping, 'first_name');
            bindCheckoutField('#form-field-sa_ln', window.checkout.shipping, 'last_name');
            bindCheckoutField('#form-field-sa_address1', window.checkout.shipping, 'address');
            bindCheckoutField('#form-field-sa_address2', window.checkout.shipping, 'address2');
            bindCheckoutField('#form-field-sa_city', window.checkout.shipping, 'city');
            bindCheckoutField('#form-field-sa_county', window.checkout.shipping, 'state');
            bindCheckoutField('#form-field-sa_postal_code', window.checkout.shipping, 'zip');
            // bindCheckoutField('#form-field-sa_country', window.checkout.shipping, 'country');
            checkoutForm.querySelector('#form-field-sa_country').value = 'United Kingdom';

            // whether we are shipping to billing address or not
            bindCheckoutCheckbox('#form-field-diff_shipping_address-0', window.checkout, 'shipToBillingAddress');


            // add the toggle show/hide for the shipping address checkbox
            let shippingAddressToggle = checkoutForm.querySelector('#form-field-diff_shipping_address-0');

            // when the field changes, update the stored value
            shippingAddressToggle.addEventListener("change", function(event) {
                showHideShippingAddressForm();
            });
        }

        // sets the value in the field from the checkout object, binds the field
        // so that changes are saved back to the checkout object. This ensures
        // that changes persist when the page is refreshed.
        function bindCheckoutField(selector, store, field) {
            // set initial value
            let input = checkoutForm.querySelector(selector);
            input.value = store[field];

            // when the field changes, update the stored value
            input.addEventListener("change", function(event) {
                store[field] = event.target.value;
                window.checkout.save();
            });
        }

        function bindCheckoutCheckbox(selector, store, field) {
            // set initial value
            let input = checkoutForm.querySelector(selector);
            input.checked = store[field];

            // when the field changes, update the stored value
            input.addEventListener("change", function(event) {
                store[field] = event.target.checked;
                window.checkout.save();
            });
        }

        async function startCheckoutProcess() {
            console.log('CHECKOUT: Starting checkout process');
            const valid = await validateContactDetailsForm()

            if (!valid || cart.length <= 0) {
                return
            }

            const validPayment = await validatePaymentForm()

            if (!validPayment) {
                return
            }

            if (isPaymentMethodPhoneProvider()) {
                if (window.payment.hasAuthorisedPaymentIntent()) {
                    // already authorised, run the checkout
                    console.log('CHECKOUT: Using google/apple pay - processing checkout');
                } else {
                    // not authorised yet, open auth window
                    console.log('CHECKOUT: Using google/apple pay - getting authorised payment intent');
                    // document.querySelector('.gpay-button, .apple-pay-button').click();

                    configurePaymentIntent();

                    // we don't want to submit this way, we need the payment intent authorised first
                    return;
                }
            } else {
                console.log('CHECKOUT: Using card');
            }

            await doCheckout()
        }

        async function moveToContactDetailsStep() {
            console.log('CHECKOUT: Moving to contact details step');
            hidePaymentForm();
            showContactDetailsForm();
        }

        async function moveToPaymentStep() {
            console.log('CHECKOUT: Attempting to move to payment step');
            const valid = await validateContactDetailsForm()

            if (!valid || cart.length <= 0) {
                console.log('CHECKOUT: Form is not valid, cannot move to payment');
                return
            }

            console.log('CHECKOUT: Moving to payment');
            hideContactDetailsForm();
            showPaymentForm();
        }

        async function validateContactDetailsForm() {
            console.log('CHECKOUT: Validating form');

            window.utils.forms.removeErrorMessage(checkoutForm);

            // validate the user account and billing sections - these are always required
            let requiredFields = [
                '#form-field-acc_email',
                '#form-field-acc_fn',
                '#form-field-acc_ln',
                '#form-field-acc_phone',
                '#form-field-ba_fn',
                '#form-field-ba_ln',
                '#form-field-ba_address1',
                '#form-field-ba_city',
                '#form-field-ba_county',
                '#form-field-ba_postal_code',
                '#form-field-ba_country'
            ];

            let addressFields = [
                '#form-field-ba_address1',
                '#form-field-ba_city',
                '#form-field-ba_county',
                '#form-field-ba_postal_code',
                '#form-field-ba_country',
                '#form-field-sa_address1',
                '#form-field-sa_city',
                '#form-field-sa_county',
                '#form-field-sa_postal_code',
                '#form-field-sa_country',
            ];
            let phoneFields = [
                '#form-field-acc_phone',
            ];

            let shippingRequiredFields = [
                '#form-field-sa_fn',
                '#form-field-sa_ln',
                '#form-field-sa_address1',
                '#form-field-sa_city',
                '#form-field-sa_county',
                '#form-field-sa_postal_code',
                '#form-field-sa_country',
            ];

            // if we're using a different shipping address then require those fields too
            if (!document.querySelector('input[name="form_fields[diff_shipping_address]"]').checked) {
                requiredFields = requiredFields.concat(shippingRequiredFields);
            }

            // remove any existing error messages from ALL fields (even ones we may not require right now)
            document.querySelectorAll(requiredFields.concat(shippingRequiredFields)).forEach((input) => {
                window.utils.forms.removeErrorMessage(input);
            });

            // validate the required fields
            document.querySelectorAll(requiredFields).forEach((input) => {
                if (!input.value) {
                    window.utils.forms.addErrorMessage('This field is required', input);
                } else if (input.type === 'email' && !validateEmail(input.value)) {
                    window.utils.forms.addErrorMessage('Please enter a valid email address', input);
                } else if (input.name.includes('postal_code') && !isValidUKPostalCode(input.value)) {
                    window.utils.forms.addErrorMessage('Please enter a valid postcode', input);
                }
            })

            // validate that they have accepted the T&Cs
            const conditionInput = document.querySelector('input[name="form_fields[term_and_conditions]"]')
            // remove any existing errors
            window.utils.forms.removeErrorMessage(conditionInput);
            if (!conditionInput.checked) {
                window.utils.forms.addErrorMessage('Please read and accept the terms and conditions to proceed with your order', conditionInput);
            }

            // validate that no address fields are over 40 characters (Royal Mail limit)
            document.querySelectorAll(addressFields).forEach((input) => {
                if (input.value.length > 40) {
                    window.utils.forms.addErrorMessage('This field cannot be over 40 characters, please shorten it', input);
                }
            })

            // validate that phone number fields are in the correct format
            document.querySelectorAll(phoneFields).forEach((input) => {
                const value = input.value.trim();
                // Check if the value matches the UK phone number format
                if (!window.DigitalNature.utils.validations.validatePhoneNumber(value)) {
                    window.utils.forms.addErrorMessage('Please enter a valid UK phone number.', input);
                }
            });



            let errorCount = document.querySelectorAll('#klira-checkout-contact-details .form-field-error').length;

            console.log(`CHECKOUT VALIDATION: Found ${errorCount} errors`);

            if (errorCount > 0) {
                // if there are errors then make sure we're on this step to see them
                await moveToContactDetailsStep();
            }

            return errorCount === 0;
        }

        async function validatePaymentForm() {
            console.log('CHECKOUT: Validating payment form');

            window.utils.forms.removeErrorMessage(checkoutForm);

            let cardFields = [
                '#form-field-kl_card_number',
                '#form-field-kl_expiry_date',
                '#form-field-kl_cvv'
            ];

            // remove any existing error messages from ALL fields (even ones we may not require right now)
            document.querySelectorAll(cardFields).forEach((input) => {
                window.utils.forms.removeErrorMessage(input);
            });

            // validate the payment section
            switch (getSelectedPaymentMethod()) {
                case PAYMENT_METHOD_CARD:
                    // check card number format
                    const cardNumberRegex = /^[0-9]{13,19}$/
                    if (!inputCardNumber.value) {
                        window.utils.forms.addErrorMessage('This field is required', inputCardNumber);
                    } else if (!cardNumberRegex.test(inputCardNumber.value.trim().replace(/\s+/g, ''))) {
                        window.utils.forms.addErrorMessage('Invalid card number', inputCardNumber);
                    }

                    if (!inputCardExpiry.value) {
                        window.utils.forms.addErrorMessage('This field is required', inputCardExpiry);
                    } else if (window.payment.isExpiredCard(inputCardExpiry.value)) {
                        window.utils.forms.addErrorMessage('This card has expired', inputCardExpiry);
                    }

                    if (!inputCardCvv.value) {
                        window.utils.forms.addErrorMessage('This field is required', inputCardCvv);
                    }
                    break;
                case PAYMENT_METHOD_CARD_EXISTING:
                case PAYMENT_METHOD_GOOGLE_PAY:
                case PAYMENT_METHOD_APPLE_PAY:
                default:
                    // no validation needed
                    break;
            }

            let errorCount = document.querySelectorAll('#klira-checkout-payment-details .form-field-error').length;

            console.log(`CHECKOUT PAYMENT VALIDATION: Found ${errorCount} errors`);

            return errorCount === 0;
        }

        function initialisePhonePaymentProviders() {
            window.payment.initialisePhonePaymentProviders().then(() => {
                if (window.payment.supportsApplePay()) {
                    showPaymentMethodApplePay();
                } else if (window.payment.supportsGooglePay()) {
                    showPaymentMethodGooglePay();
                }
            });
        }

        function isPaymentMethodPhoneProvider() {
            return [PAYMENT_METHOD_GOOGLE_PAY, PAYMENT_METHOD_APPLE_PAY].includes(getSelectedPaymentMethod());
        }

        /**
         * Promotional gifts are configured in admin (Promotions), so the checkout asks the
         * server what this customer qualifies for rather than knowing about any gift itself.
         * The same eligibility is resolved again on /process - nothing here decides what ships.
         */
        async function getPromotionGifts() {
            try {
                // window.utils.request.post returns response.json(), so this is already parsed.
                // Some endpoints double-encode and hand back a string, so cope with both.
                let response = await window.utils.request.post(
                    '/wp-json/klira/checkout/promotion-gifts',
                    {
                        items: window.cart.buildLineItems(),
                    }
                );

                if (typeof response === 'string') {
                    response = JSON.parse(response);
                }

                return response?.gifts || [];
            } catch (error) {
                // a promotion failing to load must never block the order summary rendering
                console.log('CHECKOUT: Could not load promotion gifts', error);
                return [];
            }
        }

        /**
         * Renders the gifts earned by one cart line item, directly beneath it, so a gift reads as
         * belonging to the product that earned it rather than to whatever happens to be last.
         */
        function appendPromotionGiftOrderSummaryItems(productList, gifts) {
            gifts.forEach(function(gift) {
                const giftItem = document.createElement('div');
                giftItem.classList.add('kl-order-item');
                giftItem.classList.add('kl-order-item-gift');

                const quantityLabel = gift.quantity > 1 ? ` x${gift.quantity}` : '';
                const wasLabel = gift.was ? `<span class="kl-order-item-inline-was">${gift.was}</span>` : '';

                giftItem.innerHTML = `
                <div class="kl-order-item-media-row">
                    <div class="kl-order-item-media">
                        <img src="${gift.image}" alt="${gift.title}" onerror="this.style.display='none'">
                    </div>
                    <div class="kl-order-item-content">
                        <div class="kl-order-item-main-row">
                            <div class="kl-order-item-left">
                                <p class="kl-order-item-title">${gift.title}${quantityLabel}</p>
                                <p class="kl-order-item-subtitle">${gift.subtitle || ''}</p>
                            </div>
                            <div class="kl-order-item-right">
                                 <p class="kl-order-item-inline-price">FREE ${wasLabel}</p>
                            </div>
                        </div>
                    </div>
                </div>`;

                productList.appendChild(giftItem);
            });
        }

        function getOrderSummaryItemSubtitle(product) {
            const subscriptionLength = `${product?.subscription_length || ''}`.toLowerCase();
            const productId = `${product?.id || ''}`.toLowerCase();

            if (!subscriptionLength || subscriptionLength === 'gift_card_redeemed') {
                return '';
            }

            if (subscriptionLength === '4 months') {
                return '120-day personalised treatment plan';
            }

            if (subscriptionLength === 'longevity' || subscriptionLength.includes('longevity') || productId.includes('longevity')) {
                return '12-month personalised nighttime treatment plan';
            }

            if (subscriptionLength === '12 months' || subscriptionLength.includes('annual') || subscriptionLength.includes('year')) {
                return 'Annual Plan';
            }

            if (subscriptionLength === '3 months' || subscriptionLength.includes('quarter')) {
                return 'Auto Replenish';
            }

            if (subscriptionLength === 'one_time_purchase' || subscriptionLength.includes('one_time')) {
                return 'One Off Purchase';
            }

            if (subscriptionLength === '1 month') {
                return 'Monthly Plan';
            }

            return '';
        }

        async function renderOrderSummary() {
            const upsellDiscounts = await window.upsellDiscounts.get() || {};
            let upsellDiscountTotal = 0;

            // remove all items
            const journeyMap = {
            201: {
                label: "OILY & HYPERPIGMENTED SKINSIZES",
                image: "https://stg-api.klira.skin/uploads/69dc64b9a2fa561784a39c375877fa69d2e18f86_1_e21d222d8f.png"
            },
            202: {
                label: "OILY & NON-HYPERPIGMENTED SKINSIZES",
                image: "https://stg-api.klira.skin/uploads/oily_and_nonhyperpigmented_68fac3cabc.png"
            },
            203: {
                label: "DRY & HYPERPIGMENTED SKINSIZES",
                image: "https://stg-api.klira.skin/uploads/dry_and_hyperpigmented_4a5e5a1e4c.png"
            },
            204: {
                label: "DRY & NON-HYPERPIGMENTED SKINSIZES",
                image: "https://stg-api.klira.skin/uploads/dry_and_nonhyperpigmented_6b508602e1.png"
            }
        };
            const productList = orderSummary.querySelector('.order-list');
            const couponList = document.querySelector('.coupon-list-group');
            const totalPriceEl = orderSummary.querySelector('.order-total-price .elementor-heading-title')
            const couponForm = orderSummary.querySelector('#order-summary-coupons')
            productList.innerHTML = null;
            couponList.innerHTML = null;
            totalPriceEl.textContent = '';

            if (window.cart.isEmpty()) {
                return
            }

            let hasRenderedFirstSection = false;

            // fetched once for the whole summary, then matched to line items by addon id
            const promotionGifts = await getPromotionGifts();

            window.cart.items.forEach(function(item) {
                const orderItem = document.createElement('div')
                orderItem.classList.add('kl-order-item')
                if (hasRenderedFirstSection) {
                    orderItem.classList.add('kl-order-item-has-top-border');
                }

                let product = item.getProduct();
                const itemDiscount = upsellDiscounts[product.id] || 0;
                if(itemDiscount > 0) {
                  upsellDiscountTotal += itemDiscount;
                }

                let priceHtml = '';
                if (itemDiscount > 0) {
                    const discountedPrice = item.getTotalPrice() - itemDiscount;
                    priceHtml = `<ins>£${discountedPrice.toFixed(2)}</ins> <del class="kl-order-item-inline-was">£${item.getTotalPrice().toFixed(2)}</del>`;
                } else {
                    priceHtml = `£${item.getTotalPrice().toFixed(2)}`;
                }

                const itemSubtitle = getOrderSummaryItemSubtitle(product);
                const itemImageHref = product.imageUrl || '';
                const itemImageHtml = itemImageHref
                    ? `<img src="${itemImageHref}" alt="" onerror="this.style.display='none'">`
                    : '';

                let additionalFieldsHtml = '';
                if (item.additionalFields) {
                    let additionalFieldRows = '';
                    Object.keys(item.additionalFields).forEach(function(additionalField) {
                        const fieldValue = item.additionalFields[additionalField];

                        if (!fieldValue || fieldValue.length === 0) {
                            return;
                        }

                        if (additionalField === 'journey_label' || additionalField === 'journey_image') {
                            return;
                        }

                        if (additionalField === 'journey_id' || additionalField === 'journeyId') {
                            const journeyDescription = journeyMap[fieldValue]?.label || fieldValue;
                            additionalFieldRows += `<span>${journeyDescription}</span>`;
                            return;
                        }

                        let additionalFieldName = additionalField.replace(/_/g, " ");
                        additionalFieldName = additionalFieldName.charAt(0).toUpperCase() + additionalFieldName.slice(1);
                        additionalFieldRows += `<span>${additionalFieldName}: ${fieldValue}</span>`;
                    });

                    if (additionalFieldRows.length > 0) {
                        additionalFieldsHtml = `<div class="kl-order-info-additional">${additionalFieldRows}</div>`;
                    }
                }

                let orderItemHtml = `
                    <div class="kl-order-item-media-row">
                        <div class="kl-order-item-media">
                            ${itemImageHtml}
                        </div>
                        <div class="kl-order-item-content">
                            <div class="kl-order-item-main-row">
                                <div class="kl-order-item-left">
                                    <p class="kl-order-item-title">${product.name}</p>
                                    ${itemSubtitle ? `<p class="kl-order-item-subtitle">${itemSubtitle}</p>` : ''}
                                    ${itemDiscount > 0 ? `<p class="kl-order-item-discount"><span class="kl-order-price-discount">5% subscriber discount applied</span></p>` : ''}
                                    ${additionalFieldsHtml}
                                </div>
                                <div class="kl-order-item-right">
                                    <p class="kl-order-item-inline-price">${priceHtml}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="kl-cart-item-remove kl-cart-item-remove-text kl-order-item-remove-corner" data-id="${item.uid}">Remove</p>`;

                // update the item HTML
                orderItem.innerHTML = orderItemHtml;

                productList.appendChild(orderItem)

                // gifts earned by this item sit directly under it, with no top border, so they
                // read as part of the same section
                const addonId = product?.chargebeeAddOnId;
                const giftsForItem = promotionGifts.filter(function(gift) {
                    return gift.addon_id && gift.addon_id === addonId;
                });

                appendPromotionGiftOrderSummaryItems(productList, giftsForItem);

                hasRenderedFirstSection = true;
            })

            const renderedOrderItems = productList.querySelectorAll('.kl-order-item');
            if (renderedOrderItems.length > 0) {
                renderedOrderItems[renderedOrderItems.length - 1].classList.add('kl-order-item-has-bottom-border');
            }

            if (window.cart.coupons.length > 0) {
                window.utils.content.hide(couponForm);
            } else {
                window.utils.content.show(couponForm);
            }

            window.cart.coupons.forEach(function(coupon) {
                const couponItem = document.createElement('div')
                couponItem.classList.add('kl-coupon-item');

                couponItem.innerHTML = `
                    <div class="kl-coupon-item__left"">
                        <div class="kl-coupon-name">
                            ${coupon.code.toUpperCase()}
                        </div>
                        <div class="kl-coupon-remove" data-code="${coupon.code.toUpperCase()}">Remove</div>
                    </div>
                    <div class="kl-coupon-item__right">
                        <p>-£${coupon.discountAmount.toFixed(2)}</p>
                    </div>
                `;

                couponList.appendChild(couponItem)
            })

            const finalPrice = Math.max(0, window.cart.getDiscountedPrice() - upsellDiscountTotal)
            totalPriceEl.textContent = `£${finalPrice.toFixed(2)}`
        }

        async function doCheckout() {
            console.log('CHECKOUT: Submitted');

            // remove any form-wide error messages
            window.utils.forms.removeErrorMessage(checkoutForm);

            // get the card payment details
            let paymentParams = null;
            let phonePaymentMethod = false;

            switch (getSelectedPaymentMethod()) {
                case PAYMENT_METHOD_CARD:
                    // Get (and validate) the card form details
                    let expiryDateParts = inputCardExpiry.value.split(' / ');

                    window.utils.forms.removeErrorMessage(inputCardExpiry);

                    if (expiryDateParts.length !== 2) {
                        window.utils.forms.addErrorMessage('Please check your expiry date is formatted correctly', inputCardExpiry);
                        return;
                    }

                    const expMonth = expiryDateParts[0]
                    const expYear = `20${expiryDateParts[1]}`;

                    paymentParams = {
                        card: {
                            number: inputCardNumber.value.replaceAll(' ', ''),
                            cvv: inputCardCvv.value,
                            expiry_year: expYear,
                            expiry_month: expMonth
                        }
                    };

                    break;
                case PAYMENT_METHOD_CARD_EXISTING:
                    // we just offer the default card so do not need to provide any details
                    paymentParams = null
                    break;
                case PAYMENT_METHOD_GOOGLE_PAY:
                case PAYMENT_METHOD_APPLE_PAY:
                    phonePaymentMethod = true;
                    if (!window.payment.hasAuthorisedPaymentIntent()) {
                        console.error('CHECKOUT: We do not have an authorised payment intent, cannot checkout');
                        window.utils.forms.addErrorMessage('Payment has not been authorised yet, click your payment provider link to supply card details', checkoutForm);
                        return;
                    }

                    paymentParams = {
                        payment_intent_id: window.payment.authorisedPaymentIntent.id
                    };

                    break;
                default:
                    window.utils.forms.addErrorMessage('Selected payment method was not recognised', checkoutForm);
                    console.error('CHECKOUT: Did not recognise selected payment method, cannot checkout');
                    return;
            }

            // run the checkout process
            let body = document.querySelector('body');
            window.utils.animations.addLoadingSpinner(body);
            let checkoutSuccess = await window.checkout.doCheckout(paymentParams || {});

            if (!checkoutSuccess) {
                let errorMessage = window.checkout.errorMessage ?? 'Checkout failed. Please try again';
                window.utils.forms.addErrorMessage(errorMessage, checkoutForm, 30);
                window.utils.animations.removeLoadingSpinner(body);

                if (phonePaymentMethod) {
                    // reload so payment intent can be recreated
                    window.location.reload()
                }

                return;
            }


            // track checkout complete
            window.klira.klaviyo.trackCheckoutCompleted();
            // record this purchase
            await window.purchase.save();
            // clear checkout & cart
            window.cart.empty();
            window.checkout.clear();
        }

        function isMobileCheckout() {
            return window.getComputedStyle(columnsWrapper).maxWidth === '767px';
        }

        function getPhonePaymentButtonSelector() {
            return isMobileCheckout() ? `#${phonePurchaseBtnMobi.id}` : `#${phonePurchaseBtn.id}`;
        }

        async function configurePaymentIntent() {
            try {
                const upsellDiscountTotal = await window.upsellDiscounts?.totalDiscountAmount() || 0;
                const orderTotal = Math.max(0, window.cart.getDiscountedPrice() - upsellDiscountTotal);
                window.utils.animations.addLoadingSpinner(document.querySelector('body'));

                if (window.payment.hasPaymentIntent()) {
                    return;
                }

                console.log('CHECKOUT: creating payment intent');
                window.payment.createPaymentIntent(orderTotal)
                    .then(() => {
                        if (!window.payment.hasPaymentIntent()) {
                            console.log('CHECKOUT: no payment intent, cannot mount button');
                        } else if (!window.payment.hasPhonePaymentButton()) {
                            console.log('CHECKOUT: mounting payment button');

                            // noinspection JSIgnoredPromiseFromCall
                            window.payment.addPhonePaymentButton(getPhonePaymentButtonSelector());
                        }

                        window.utils.animations.removeLoadingSpinner(document.querySelector('body'));
                    });
            } catch (error) {
                console.error("CHECKOUT: authorisePaymentIntent: There was an error - ", error);
            }
        }

        function enableStoredPaymentCards() {
            if (!window.payment || window.payment.paymentList.length === 0) {
                return
            }

            // show the option to choose this payment method
            showPaymentMethodExistingCard();
            // initially hide the form as it won't have been selected yet
            hidePaymentExistingCardForm();

            const payment = window.payment.paymentList.find((i) => i.primary)

            document.querySelector('#kl-existing-cards').innerHTML = `
                <div class="kl-payment-list">
                    <div class="kl-payment-row">
                        <div class="kl-payment-item__left">
                            <div class="kl-payment-image">
                                <img src="${window.payment.renderCardLogo(payment.brand)}" alt="brand" />
                            </div>
                        </div>
                        <div class="kl-payment-item__right">${payment.masked_number}</div>
                    </div>
                </div>
            `
        }

        function getSelectedPaymentMethod() {
            return document.querySelector('input[name="method"]:checked').value;
        }

        function showHideSelectedPaymentDetails() {
            switch (getSelectedPaymentMethod()) {
                case PAYMENT_METHOD_CARD:
                    hidePaymentExistingCardForm();
                    showPaymentNewCardForm();
                    showCompletePurchaseButtons();
                    window.payment.clearPaymentIntent();
                    break;
                case PAYMENT_METHOD_CARD_EXISTING:
                    hidePaymentNewCardForm();
                    showPaymentExistingCardForm();
                    showCompletePurchaseButtons();
                    window.payment.clearPaymentIntent();
                    break;
                case PAYMENT_METHOD_GOOGLE_PAY:
                case PAYMENT_METHOD_APPLE_PAY:
                    hidePaymentNewCardForm();
                    hidePaymentExistingCardForm();
                    if (window.payment.hasAuthorisedPaymentIntent()) {
                        // already authorised, run the checkout
                        console.log('CHECKOUT: Using google/apple pay - payment intent authorised');
                        showCompletePurchaseButtons();
                    } else {
                        // not authorised yet, open auth window
                        console.log('CHECKOUT: Using google/apple pay - getting authorised payment intent');
                        hideCompletePurchaseButtons();
                        configurePaymentIntent();
                    }
                    break;
                default:
                    console.error('Did not recognise selected payment method, hiding all');
                    hidePaymentNewCardForm();
                    hidePaymentExistingCardForm();
                    return;
            }
        }

        // Complete purchase buttons
        function hideCompletePurchaseButtons() {
            window.utils.content.hide(purchaseBtn);
            window.utils.content.hide(purchaseBtnMobi);
        }

        function showCompletePurchaseButtons() {
            window.utils.content.show(purchaseBtn);
            window.utils.content.show(purchaseBtnMobi);
        }

        // payment method additional details
        function showPaymentNewCardForm() {
            window.utils.content.show(document.querySelector('#card-details-form'));
        }

        function showPaymentExistingCardForm() {
            window.utils.content.show(document.querySelector('#kl-existing-cards'));
        }

        function hidePaymentNewCardForm() {
            window.utils.content.hide(document.querySelector('#card-details-form'));
        }

        function hidePaymentExistingCardForm() {
            window.utils.content.hide(document.querySelector('#kl-existing-cards'));
        }

        // payment method options
        function showPaymentMethodExistingCard() {
            window.utils.content.show(document.querySelector('.method-saved-card'));
        }

        function showPaymentMethodGooglePay() {
            window.utils.content.show(document.querySelector('.method-google-pay'));
        }

        function showPaymentMethodApplePay() {
            window.utils.content.show(document.querySelector('.method-apple-pay'));
        }

        function hidePaymentMethodExistingCard() {
            window.utils.content.hide(document.querySelector('.method-saved-card'));
        }

        function hidePaymentMethodGooglePay() {
            window.utils.content.hide(document.querySelector('.method-google-pay'));
        }

        function hidePaymentMethodApplePay() {
            window.utils.content.hide(document.querySelector('.method-apple-pay'));
        }












        async function initCheckout() {
            if (window.cart.isEmpty()) {
                // nothing in cart, hide everything
                const emptyCart = document.createElement('div')
                emptyCart.classList.add('elementor-column', 'elementor-col-33');
                emptyCart.style.flex = 1;
                emptyCart.innerHTML = `<p>Your cart is empty.</p>`;
                checkoutForm.after(emptyCart);

                hideGuestArea();
                hideLoginForm();
                hideGuestForm();
                hideCheckoutForm();
                hideCompletePurchaseButtons();
                return;
            }

            lockFields();
            showHideEmailAndLoginForms()
            showHideShippingAddressForm()
            fillCheckoutForm()
            await renderOrderSummary()
            addCardFormFormattingListeners()

            // hide payment methods that _may_ not be used
            hidePaymentMethodExistingCard();
            hidePaymentMethodGooglePay();
            hidePaymentMethodApplePay();

            if (
                !window.cart.hasMultipleChargeItems() &&
                !window.cart.hasMultipleSubscriptionItems() &&
                !window.cart.hasChargeAndSubscriptionItems()
            ) {
                initialisePhonePaymentProviders()
            }

            if (window.customer.isLoggedIn()) {
                window.payment.getStoredPaymentCards().then(() => {
                    enableStoredPaymentCards();
                })
            }
        }

        // initialise immediately
        initCheckout()
    });
})( jQuery );
